import types from '../mutation-types';
import AccountNotesAPI from '../../api/accountNotes';

const state = {
  records: [],
  meta: {
    totalCount: 0,
    currentPage: 1,
    perPage: 25,
  },
  uiFlags: {
    isFetching: false,
  },
};

const getters = {
  getAllNotes(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  async fetch({ commit }, page = 1) {
    commit(types.SET_ACCOUNT_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await AccountNotesAPI.get(page);
      commit(types.SET_ACCOUNT_NOTES, data.data.payload);
      commit(types.SET_ACCOUNT_NOTES_META, {
        totalCount: data.data.meta.total_count,
        currentPage: data.data.meta.current_page,
        perPage: data.data.meta.per_page,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_ACCOUNT_NOTES_UI_FLAG, { isFetching: false });
    }
  },
};

const mutations = {
  [types.SET_ACCOUNT_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_ACCOUNT_NOTES](_state, data) {
    _state.records = data;
  },
  [types.SET_ACCOUNT_NOTES_META](_state, data) {
    _state.meta = { ..._state.meta, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
